import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../../../constants/constants";
import TblComp from "../../../../../react_table";
import { Button } from "reactstrap";
import {
  HandleDocumentTypeFetch,
  editDocumentType,
  HandleDocumentTypeDelete,
} from "../../../../../actions/settings/types/document_type_actions";
import { clearDocumentTypeForm } from "../../../../../actions/settings/types/document_type_actions";
import ExportCSV from "../../../../../constants/Exports/xlsExport";
import DeleteModal from "../../../../../constants/deleteModal";

export const DocumentTypesTable = (props) => {
  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState(false);
  const toggle = () => setModal(!modal);
  const dispatch = useDispatch();
  const { loading_doc_types, document_type_list, is_processing } = useSelector(
    (state) => state.documenttypereducer,
    shallowEqual
  );
  useEffect(() => {
    document_type_list.length === 0 && dispatch(HandleDocumentTypeFetch());
  }, [dispatch, document_type_list.length]);

  const headers = ["Id", "Title", "Description"];
  return (
    <>
      <DeleteModal
        modal={modal}
        toggle={toggle}
        name="document type"
        handleDelete={() =>
          dispatch(HandleDocumentTypeDelete(selected, toggle))
        }
        is_processing={is_processing}
      />
      <Button
        className="btn ticket-btn my-3 me-2"
        onClick={(e) => {
          dispatch(clearDocumentTypeForm(e));
          props.toggle();
        }}
      >
        Add document type
      </Button>
      <ExportCSV
        csvData={document_type_list}
        fileName="documentypes"
        headers={headers}
      />

      <TblComp
        columns={[
          {
            Header: "Title",
            accessor: "document_name",
            filter: "fuzzyText",
          },
          {
            Header: "Description",
            accessor: "description",
            filter: "fuzzyText",
          },
          {
            id: "actions", // Required because our accessor is not a string
            Header: "Action",
            maxWidth: 100,
            accessor: (full) => (
              <Actions
                editHandler={(selected_row) => [
                  dispatch(editDocumentType(selected_row)),
                  props.toggle(),
                ]}
                data_item={full}
                link_url={""}
                deleteHandler={(selected_id) => [
                  toggle(),
                  setSelected(selected_id.id),
                ]}
              />
            ),
          },
        ]}
        data={document_type_list}
        loading={loading_doc_types}
      />
    </>
  );
};
